import React from 'react';
import { useDeleteAsoRequestMutation } from '../apiAso';
import DeleteAsoModal from '../modals/DeleteAsoModal';

interface DeleteAsoRequestModalProps {
  requestId: number;
  requestName?: string;
  onCancel: () => void;
}

const DeleteAsoRequestModal: React.FC<DeleteAsoRequestModalProps> = ({
  requestId,
  requestName,
  onCancel,
}) => {
  const [deleteAsoRequest, { isLoading: confirmLoading }] = useDeleteAsoRequestMutation();
  const modalTitle = `Delete ASO request #${requestId}${requestName ? ` ${requestName}` : ''}?`;

  return (
    <DeleteAsoModal
      dataTestId="DeleteAsoRequestConfirmationModal"
      modalTitle={modalTitle}
      message="This will remove the ASO request. Calculations referencing it may require re-selection."
      onCancel={onCancel}
      confirmLoading={confirmLoading}
      onConfirm={() => deleteAsoRequest(requestId)}
    />
  );
};

export default DeleteAsoRequestModal;
